<template>
    <div class="image-card">
        <div class="blog-author mb--20" :class="isBanner ? 'fix-banner' : ''" :style="`background-image: url(${getUrlBase}${bgImg}.png);`">
            <div class="author">
                <div class="author-thumb">
                    <img v-show="avatar != null" :src="`${img_base}${avatar}.png`" alt="avatar">
                </div>
                <div class="info white">
                    <h6 class="white">{{ title }}</h6>
                    <ul class="list-style">
                        <li v-for="(r, index) in list" :key="index">{{ r }}</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: "ImageCard",
    props: [
        "title",
        "list",
        "avatar",
        "bgImg",
        "isBanner"
    ],
    data() {
        return {
            img_base: "https://cdn.redgirasol.com/nuevo_portal/icons/icon-",
            img_base_foto: "https://cdn.redgirasol.com/nuevo_portal/fotografias/foto-",
            img_base_banner: "https://cdn.redgirasol.com/nuevo_portal/banners/banner-"
        }
    },
    computed: {
        getUrlBase() {
            return this.isBanner ? this.img_base_banner: this.img_base_foto;
        }
    }
}

</script>

<style scoped>

.image-card > div.blog-author {
    background-repeat: round;
    padding-left: 20px;
    padding-right: 13px;
}

.blog-author {
    min-height: 15.3rem !important;
}

ul.list-style {
    line-height: 16px;
}

.author-thumb {
    width: 5rem;
}

.fix-banner {
    background-size: cover;
    background-repeat: no-repeat !important;
    background-position: -1rem;
}

@media only screen and (max-width: 575px) {
    .author {
        margin-top: 6rem !important;
    }
}

</style>